<div class="modal-container popup-general modal-lg top_150_negative row">
    <div class="modal-container-header col-12">
        <span></span>
        <span class="k-icon k-i-close" (click)="modalClosePopup()"></span>
    </div>
    <div class=" modal-container-section col-12">
        <dms-gestion-form [transmitter]="transmitter">
        </dms-gestion-form>

    </div>
</div>
